import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle } from "lucide-react";

/**
 * Polls /api/health/service and renders a single banner when any AI service is
 * degraded. Role-aware: backend returns the owner-specific message when signed
 * in as owner, customer-friendly otherwise.
 */
export default function ServiceHealthBanner() {
  const [degraded, setDegraded] = useState([]); // array of {service, message}

  useEffect(() => {
    let stopped = false;

    const check = async () => {
      try {
        const { data } = await api.get("/health/service");
        if (stopped) return;
        const items = Object.values(data?.services || {}).filter(s => s.status === "degraded");
        setDegraded(items);
      } catch {
        // silent — banner stays hidden if the probe itself fails
      }
    };

    check();
    const id = setInterval(check, 60_000); // poll every 60s
    return () => { stopped = true; clearInterval(id); };
  }, []);

  if (!degraded.length) return null;

  return (
    <div className="mb-6 space-y-2" data-testid="service-health-banner">
      {degraded.map((s) => (
        <div
          key={s.service}
          data-testid={`service-health-${s.service}`}
          className="flex items-start gap-3 border border-amber-500/40 bg-amber-500/10 text-amber-200 px-4 py-3 text-sm"
        >
          <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0 text-amber-400" />
          <p className="leading-relaxed">{s.message}</p>
        </div>
      ))}
    </div>
  );
}
